import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TestQuestion } from '../../core/models/placement/placement.model';
import { TestScreenComponent } from '../test-screen/test-screen.component';

@Component({
  selector: 'app-test-wrapper',
  standalone: true,
  imports: [TestScreenComponent],
  templateUrl: './test-wrapper.component.html',
  styleUrls: ['./test-wrapper.component.scss']
})
export class TestWrapperComponent implements OnInit {

  questions: TestQuestion[] = [];
  testTitle: string = 'Placement Test';
  durationMinutes: number = 30;
  testId: string = '';
  attemptId: string = '';
  resumeData: any = null;

  constructor(private router: Router) { }

  ngOnInit(): void {

    const navState = history.state;

    if (navState && navState.questions && navState.questions.length > 0) {

      this.questions = navState.questions;
      this.testTitle = navState.testTitle || 'Placement Test';
      this.durationMinutes = navState.durationMinutes || 30;
      this.testId = navState.testId || '';
      this.attemptId = navState.attemptId || '';
    } else if (navState && navState.resumeData) {

      const data = navState.resumeData;
      this.testId = data.test_id || navState.testId || '';
      this.attemptId = data.attempt_id || navState.attemptId || '';
      this.testTitle = navState.testTitle || 'Placement Test';
      this.resumeData = data;

      if (data.test_conversation && data.test_conversation.length > 0) {
        this.questions = data.test_conversation.map((item: any) => item.question);
      }
    } else {

      this.testTitle = 'Frontend Development Test';
    }
  }

}
